import { render, staticRenderFns } from "./CuposPreinscripciones.vue?vue&type=template&id=4b11436e&"
import script from "./CuposPreinscripciones.vue?vue&type=script&lang=js&"
export * from "./CuposPreinscripciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports